import React, { useState, useEffect } from "react";
import SideBar from "../Components/SideBar.js";
import "./all_patients.css";
import { useNavigate } from "react-router-dom";
import {API_BASE_URL} from "../config.js";

export default function AllPatients() {
  const [search, setSearch] = useState("");
  const [patients, setPatients] = useState([]);
  const navigate = useNavigate();

  const filteredPatients = patients.filter((patient) =>
  patient.name?.includes(search) ||
  patient.national_number?.includes(search)
);

useEffect(() => {
  const token = localStorage.getItem("access_token");

  fetch(`${API_BASE_URL}/patients/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
     .then((data) => {
      console.log("FULL RESPONSE:", data);
      setPatients(data);
    })
    .catch((err) => console.error(err));
}, []);


  return (
    <div className="all-patients-container" dir="rtl">

      {/* SIDEBAR */}
      <div className="all-patients-right">
        <SideBar role="admin" />
      </div>

      <main className="all-patients-left">

        <div className="all-patients-bg-watermark"></div>

          {/* HEADER */}
          <div className="all-patients-header">
            <h1 className="all-patients-title">
              <span onClick={() => navigate("/accounts-manager")} className="all-patients-link"> مدير الحسابات</span>
              {" / "}
              <span className="all-patients-link active"> المرضى </span>
            </h1>

          </div>

          {/* SEARCH */}
          <div className="all-patients-search-wrapper">
          <div className="all-patients-search-container">
            <input
              type="text"
              className="all-patients-search-input"
              placeholder="ابحث عن اسم المريض أو الرقم الوطني..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <i className="fa-solid fa-magnifying-glass all-patients-search-icon"></i>
          </div>

          <button 
            className="all-patients-add-btn" 
            onClick={() => navigate("/add-patient")}
            title="إضافة مريض جديد"
          >
            <i className="fa-solid fa-plus"></i>
          </button>
        </div>

          {/* LIST */}
          <div className="all-patients-list">
            {filteredPatients.map((patient) => (
            <div
              key={patient.id}
              className="all-patients-card"
              onClick={() => navigate(`/patient-profile/${patient.id}`, {  state: { role: "admin" } })}
              >

              <div className="all-patients-icon">
                <i className="fa-solid fa-user-injured"></i>
              </div>
            
              <div className="all-patients-info">
                <h3 className="all-patients-name">{patient.name}</h3> 
               
                <div className="all-patients-details">
                  <p className="all-patients-code">  الجنس: {patient.gender}</p>
                  <p className="all-patients-code">  الرقم الوطني: {patient.national_number}</p>
                </div>
              </div>

            </div>
           
            ))}

          
          </div>
        
      </main>
    </div>
  );
} 
